import { Component, Input } from '@angular/core';

@Component({
    selector: 'partner-mart-locations-inventory',
    templateUrl: './partner-mart-locations-inventory.component.html',
    styleUrls: ['./partner-mart-locations-inventory.component.scss']
})

export class PartnerMartLocationsInventoryComponent {
    @Input()
    public storeId: number = 0;

    @Input()
    public merchantId: number = 0;

    @Input()
    public store: any = {};
}
